// ============================================
// FILE: src/components/Navbar.jsx
// ============================================
// Add to public/index.html <head>:
// <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400;1,600&family=Inter:wght@400;500;600;700;800&display=swap" rel="stylesheet" />

import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const NAV_LEFT = [
  { path: '/',           label: 'Home' },
  { path: '/rent',       label: 'Rent' },
  { path: '/sale',       label: 'Sale' },
    { path: '/interior',  label: 'Interior' },
  
];
const NAV_RIGHT = [
  { path: '/agreements', label: 'Agreements' },
  { path: '/home-loan', label: 'HomeLoan' },

  { path: '/inquiry',    label: 'Inquiry' },
];
const ALL_LINKS = [...NAV_LEFT, ...NAV_RIGHT];

// Inline SVG social icons
const IconFacebook = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);
const IconInstagram = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
  </svg>
);
const IconYoutube = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.95C5.12 20 12 20 12 20s6.88 0 8.59-.47a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" />
    <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" />
  </svg>
);


const IconThreads = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18.5 10.5c-.2-3.3-2.5-5.5-6-5.5-3.9 0-6.5 2.5-6.5 6.5S8.6 18 12.5 18c3.4 0 5.7-1.7 6.3-4.6.3-1.4-.3-2.8-1.7-3.6-1.3-.8-3.2-1.2-5.6-1.2" />
    <path d="M12.2 12.3c2.8 0 4.8.8 4.8 2.6 0 1.6-1.5 3.1-4.3 3.1-2.3 0-3.7-1.2-3.7-3 0-1.7 1.4-2.7 3.2-2.7z" />
  </svg>
);

const linkCls = (active) =>
  `flex items-center px-3.5 h-[62px] text-[11px] font-bold tracking-[0.14em] uppercase border-r border-slate-100 cursor-pointer transition-colors whitespace-nowrap select-none
   ${active ? 'text-[#063BCC]' : 'text-[#0b1220] hover:text-[#063BCC]'}`;

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <>
      {/* ── TOP BAR ─────────────────────────────────────────────────────── */}
      <div className="bg-[#0b1220] flex items-center justify-between px-6 py-2 border-b border-[#c4a55a]/20">
        <div className="flex items-center gap-2">
          <a href="https://www.facebook.com/shreesaip/" 
             target="_blank" 
             rel="noopener noreferrer"
             className="w-[27px] h-[27px] rounded-full border border-[#063BCC]/35 flex items-center justify-center text-white hover:border-[#c4a55a]/70 hover:text-amber-300 transition">
            <IconFacebook />
          </a>

          <a href="https://www.instagram.com/shreesaiproperties/" 
             target="_blank" 
             rel="noopener noreferrer"
             className="w-[27px] h-[27px] rounded-full border border-[#063BCC]/35 flex items-center justify-center text-white hover:border-[#c4a55a]/70 hover:text-amber-300 transition">
            <IconInstagram />
          </a>

          <a href="https://www.youtube.com/@shreesaiproperties1198" 
             target="_blank" 
             rel="noopener noreferrer"
             className="w-[27px] h-[27px] rounded-full border border-[#063BCC]/35 flex items-center justify-center text-white hover:border-[#c4a55a]/70 hover:text-amber-300 transition">
            <IconYoutube />
          </a>




<a
  href="https://www.threads.com/@shreesai_properties_pune"
  target="_blank"
  rel="noopener noreferrer"
  className="w-[27px] h-[27px] rounded-full border border-[#063BCC]/35 flex items-center justify-center text-white hover:border-[#c4a55a]/70 hover:text-amber-300 transition"
>
  <IconThreads />
</a>



        </div>
        <a href="tel:+919764646044"
           className="flex items-center gap-1.5 text-white text-[11px] font-semibold tracking-widest hover:text-amber-300 transition">
          <Phone size={12} />
          +91 97646 46044
        </a>
      </div>

      {/* ── DESKTOP NAV ─────────────────────────────────────────────────── */}
      <nav className="hidden lg:block bg-white border-b-2 border-[#0b1220] relative sticky top-0 z-50">
        {/* Nav height set explicitly so the overflowing logo box has a clear anchor */}
        <div className="flex items-stretch justify-between max-w-[1400px] mx-auto px-6" style={{ height: '62px' }}>

          {/* Left links */}
          <div className="flex items-stretch" style={{ marginLeft: '5cm' }}>
            {NAV_LEFT.map((l) => (
              <Link key={l.path} to={l.path} className={linkCls(pathname === l.path)}>
                {l.label}
              </Link>
            ))}
          </div>

          {/* ── Centered logo box ──
               • Sits absolutely centred on the nav bar
               • Top edge aligns with top of nav (top-0), not floating above it
               • Fixed width so it never clips text
               • Logo image capped at 40px tall so it fits inside 62px nav
               • Brand name on one line below using nowrap
          */}
          <div
            className="absolute left-1/2 -translate-x-1/2 top-0 bg-white border-2 border-[#063BCC]/40 z-10 rounded-b-md shadow-md flex flex-col items-center justify-center"
            style={{
              width: '160px',
              height: '90px',          /* taller than the nav bar — hangs down below it */
              paddingTop: '6px',
              paddingBottom: '8px',
              paddingLeft: '12px',
              paddingRight: '12px',
            }}
          >
           <a href="/">
  <img
    src="/images/logo1.jpeg"
    alt="Shree Sai Properties"
    style={{
      height: '90px',
      width: 'auto',
      objectFit: 'contain',
      display: 'block',
    }}
  />
</a>
            {/* <span
              className="font-bold text-[#6A0DAD] whitespace-nowrap leading-tight"
              style={{ fontSize: '10px',  letterSpacing: '0.03em' }}
            >
              Shree Sai Properties
            </span> */}
          </div>

          {/* Right links */}
          <div className="flex items-stretch">
            {NAV_RIGHT.map((l) => (
              <Link key={l.path} to={l.path} className={linkCls(pathname === l.path)}>
                {l.label}
              </Link>
            ))}
          </div>

        </div>
      </nav>

      {/* ── MOBILE NAV ──────────────────────────────────────────────────── */}
      <nav className="lg:hidden bg-[#0b1220] sticky top-0 z-50 border-b border-[#c4a55a]/25">
        <div className="flex items-center justify-between px-5 py-3">
          <div className="flex items-center justify-center">
              <a href="/">
  <img
    src="/images/logo1.jpeg"
    alt="Shree Sai Properties"
    className="h-16 w-auto object-contain"
  />
  </a>
</div>
          <button onClick={() => setOpen(!open)} className="p-2 rounded text-[#c4a55a] hover:bg-white/5 transition">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {open && (
          <div className="border-t border-[#c4a55a]/15 pb-3">
            {ALL_LINKS.map((l) => (
              <Link key={l.path} to={l.path} onClick={() => setOpen(false)}
                className={`flex items-center px-5 py-3 text-[11px] font-bold tracking-[0.16em] uppercase transition
                  ${pathname === l.path
                    ? 'text-[#c4a55a] bg-white/5'
                    : 'text-white/70 hover:text-[#c4a55a] hover:bg-white/5'}`}>
                {l.label}
              </Link>
            ))}
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;